export const libraryMessages = {
    digitalLibrary: {
        key: 'content.labelsAndTitles.DIGITAL_LIBRARY'
    },
    lookingFor: {
        key: 'content.labelsAndTitles.LOOKING_FOR'
    },
    articleDiscussion: {
        key: 'content.labelsAndTitles.ARTICLE_DISCUSSION'
    },
    latestArticles: {
        key: 'content.labelsAndTitles.LATEST_ARTICLES'
    },
    back: {
        key: 'global.actions.BACK'
    },
    by: {
        key: 'content.labelsAndTitles.BY'
    },
    createdOn: {
        key: 'content.labelsAndTitles.CREATED_ON'
    },
    suggestedArticle: {
        key: 'content.labelsAndTitles.SUGGESTED_ARTICLE'
    },
    articlesAndVideos: {
        key: 'content.labelsAndTitles.ARTICLES_AND_VIDEOS'
    },
    searchPlaceholder: {
        key: 'content.labelsAndTitles.SEARCH_CONTENT_PLACEHOLDER'
    },
    read: {
        key: 'content.labelsAndTitles.READ'
    },
    searchResults: {
        key: 'content.labelsAndTitles.SEARCH_RESULTS'
    },
    seeAll: {
        key: 'global.actions.SEE_ALL'
    },
    searching: {
        key: `content.labelsAndTitles.SEARCHING`
    },
    thereAre: {
        key: `content.labelsAndTitles.THERE_ARE`
    },
    searchResultFor: {
        key: `content.labelsAndTitles.SEARCH_RESULT_FOR`
    },
    downloadExcel: {
        key: `content.labelsAndTitles.DOWNLOAD_EXCEL`
    },
    noResultFoundMessage: {
        key: "global.errors.NO_RESULT_FOUND",
    },
    browseByTech: {
        key: 'content.labelsAndTitles.BROWSE_BY_TECHNOLOGY'
    },
}


